module.exports = __webpack_public_path__ + "images/corners/Crown.eefe3921262a38fdf79092e4f545aa78.jpg";